import React from 'react';
import { FadeIn } from './FadeIn';
import { DumbbellIcon, MountainIcon, ShieldCheckIcon, GiftIcon, CheckCircle2Icon } from 'lucide-react';
export function TriadAndBonuses() {
  const triad = [{
    icon: <MountainIcon className="w-8 h-8 text-white" data-id="element-105" />,
    title: 'Técnica para Terrenos Reales',
    desc: 'Subidas, bajadas, senderos, barro, piedras y superficies irregulares. No más clases genéricas copiadas del running de calle.'
  }, {
    icon: <DumbbellIcon className="w-8 h-8 text-white" data-id="element-106" />,
    title: 'Fuerza para Montaña',
    desc: 'Ejercicios específicos para piernas, core, estabilidad, tobillos y trabajo excéntrico, claves para correr mejor y prevenir lesiones.'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8 text-white" data-id="element-107" />,
    title: 'Seguridad y Organización',
    desc: 'Checklist, control de grupo, elementos necesarios, adaptación al clima y criterios básicos para que cada salida sea más profesional.'
  }];
  const bonuses = ['Bono 1: 30 Clases de Trail Running Listas para Usar', 'Bono 2: Banco de Ejercicios de Técnica, Fuerza y Coordinación', 'Bono 3: Planificador Mensual de Entrenamientos Trail', 'Bono 4: Guía de Seguridad para Salidas Outdoor', 'Bono 5: Kit de Captación de Alumnos para Profes de Trail Running'];
  return <section className="py-24 px-4 bg-brand-surface border-t border-brand-muted/10" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        {/* The Triad */}
        <FadeIn className="mb-20" data-id="element-110">
          <div className="text-center mb-16" data-id="element-111">
            <h2 className="text-brand-volt font-bold tracking-widest text-sm mb-4" data-id="element-112">
              LA TRÍADA DEL TRAIL RUNNING
            </h2>
            <h3 className="text-4xl sm:text-5xl font-black text-white" data-id="element-113">
              NO ES SOLO CORRER. <br data-id="element-114" /> ES SABER ADAPTARSE AL TERRENO.
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-115">
            {triad.map((item, i) => <div key={i} className="bg-brand-volt p-8 transform hover:-translate-y-2 transition-transform h-full" data-id="element-116">
                <div className="mb-6" data-id="element-117">{item.icon}</div>
                <h4 className="text-2xl font-bold text-white mb-3" data-id="element-118">
                  {item.title}
                </h4>
                <p className="text-white/90 font-medium leading-relaxed normal-case" data-id="element-119">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>

        {/* Bonuses */}
        <FadeIn delay={0.2} data-id="element-120">
          <div className="bg-brand-dark border border-brand-muted/20 p-8 sm:p-12" data-id="element-121">
            <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-122">
              <div className="flex-1" data-id="element-123">
                <div className="inline-flex items-center gap-2 text-brand-volt font-bold tracking-widest text-sm mb-6" data-id="element-124">
                  <GiftIcon className="w-5 h-5" data-id="element-125" />
                  BONUS EXCLUSIVOS
                </div>
                <h3 className="text-3xl sm:text-4xl font-black text-white mb-6" data-id="element-126">
                  HERRAMIENTAS LISTAS <br data-id="element-127" /> PARA USAR DESDE HOY
                </h3>
                <p className="text-gray-400 text-lg normal-case mb-8" data-id="element-128">
                  No te damos solo información. Te damos clases, planillas,
                  ejercicios, guías y recursos para que puedas implementar el
                  sistema en tu próxima clase de trail running.
                </p>
              </div>

              <div className="flex-1 w-full" data-id="element-129">
                <ul className="space-y-4" data-id="element-130">
                  {bonuses.map((bonus, i) => <li key={i} className="flex items-start gap-4 bg-brand-surface p-4 border border-brand-muted/10" data-id="element-131">
                      <CheckCircle2Icon className="w-6 h-6 text-brand-volt shrink-0 mt-0.5" data-id="element-132" />
                      <span className="text-white font-medium normal-case" data-id="element-133">
                        {bonus}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}